import { moveToFulfilled, moveToPending, moveToRejected, remove } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import {
  ClientSharePointWebLinkAttachmentDestroyAction,
  ClientSharePointWebLinkAttachmentDetailsLoadFulfilledAction,
  ClientSharePointWebLinkAttachmentDetailsLoadPendingAction,
  ClientSharePointWebLinkAttachmentDetailsLoadRejectedAction,
} from '../../domains/resolveClientSharePointWebLink/actions.types';

import { ClientSharePointWebLinkDetails } from './types';

export type ClientSharePointWebLinkAction =
  | ClientSharePointWebLinkAttachmentDetailsLoadFulfilledAction
  | ClientSharePointWebLinkAttachmentDetailsLoadPendingAction
  | ClientSharePointWebLinkAttachmentDetailsLoadRejectedAction
  | ClientSharePointWebLinkAttachmentDestroyAction;

const initialState: ClientSharePointWebLinkDetails = {
  pending: { byId: {} },
  fulfilled: { byId: {} },
  rejected: { byId: {} },
};

const destroyClientSharePointWebLink = (state: ClientSharePointWebLinkDetails, webLinkId: string) =>
  remove(state, [webLinkId]);

const reducer: Reducer<ClientSharePointWebLinkDetails, ClientSharePointWebLinkAction> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case 'SHAREPOINT_WEBLINK_DETAILS.LOAD_REJECTED':
      return moveToRejected(state, [action.payload.clientSharePointWebLink.id], action.payload.error);
    case 'SHAREPOINT_WEBLINK_DETAILS.LOAD_PENDING':
      return moveToPending(state, [action.payload.clientSharePointWebLink.id]);
    case 'SHAREPOINT_WEBLINK_DETAILS.LOAD_FULFILLED':
      return moveToFulfilled(state, {
        [action.payload.clientSharePointWebLink.id]: action.payload.clientSharePointWebLink,
      });
    case 'SHAREPOINT_WEBLINK.DESTROY':
      return destroyClientSharePointWebLink(state, action.payload.clientSharePointWebLinkId);
    default:
      return state;
  }
};

export default reducer;
